module.exports = {
  CARD_SCHEME_FEE: 'card_scheme_fee',
  PSP_FEE: 'psp_fee',
  ACQUIRER_FEE: 'acquirer_fee',
  PSP_MARKUP_FEE: 'psp_markup_fee',
  GATEWAY_FEE: 'gateway_fee',
  INTERCHANGE_FEE: 'interchange_fee',
  MISCELLANEOUS_FEES: 'miscellaneous_fees',
  INTERCHANGE_PLUS_MARKUP_FEE: 'interchange_plus_markup_fee',
  INTERCHANGE_PLUS_CS_MARKUP_FEE: 'interchange_plus_cs_markup_fee',
  INTERCHANGE_REFUND_FEE: 'interchange_refund_fee',
  CHARGEBACK_FEE: 'chargeback_fee',
  FRAUD_SCREENING_FEE: 'fraud_screening_fee',
  SCA_SCREENING_FEE: 'sca_screening_fee',
  '3D_SECURE_FEE': '3d_secure_fee',
};
